import axios from 'axios'

/**
 * The server's own sentence where there is one, so a page can render `error.message` and need no
 * opinion about axios.
 *
 * Lifted out of `mobileHomeLayout.ts`, where it was written first and where five other pages then
 * re-implemented it — three of them exporting the same NAME with a different signature. The server
 * puts the useful text in `response.data.message`; axios's own `err.message` is the HTTP status,
 * which tells an operator nothing about what their request got wrong, and a page's own sentence is
 * better than either when neither is there.
 *
 * Every former copy now re-exports this one, so their callers did not have to change and there is a
 * single place to fix the next thing we learn about an error body.
 */
export function apiErrorMessage(err: unknown, fallback?: string): string {
    if (axios.isAxiosError(err)) {
        const fromBody = (err.response?.data as { message?: string } | undefined)?.message
        if (fromBody) return fromBody
        if (err.message) return err.message
    }
    // `fallback` is the document pages' contract — they pass a sentence of their own for anything that
    // is not an axios error. Optional so the callers that never had one keep reading the error itself,
    // which is what their pages render today.
    if (fallback !== undefined) return fallback
    return err instanceof Error ? err.message : String(err)
}
